import { LandingPageExperience } from '../ui';

export function LandingPage() {
  return <LandingPageExperience />;
}
